import { IPartnerLeadDataDto } from "services/caju/salesForce/iPartnerLeadDataDto";
import { IStep3FormValues } from "./iStep3FormValues";

export function getDtoFromStep3PartnerFormValues(values: IStep3FormValues) {
  const result: IPartnerLeadDataDto = {
    partners_segment__c: values.partners_segment,
    product_portfolio__c: values.product_portfolio,
    partners_segment_portfolio__c: values.partners_segment_portfolio,
    client_employees__c: values.client_employees,
    partners_reason__c: values.partners_reason,

    utm_source__c: values.utm_data?.utm_source,
    utm_medium__c: values.utm_data?.utm_medium,
    utm_campaign__c: values.utm_data?.utm_campaign,
    utm_term__c: values.utm_data?.utm_term,
    utm_content__c: values.utm_data?.utm_content,
  };

  return result;
}
